import { getAllSassOrg } from '@/apis/company';

export default {
  data() {
    return {
      zrShow: false,
      zrCompanyId: 0, // 责任单位
      zrOptions: []
    }
  },
  methods: {
    loadData() {

    }
  },
  async created() {
    let res = await getAllSassOrg();
    let { orgList, orgId, roleStr } = res.data;
    this.zrOptions = [
      { text: "请选择", value: 0 },
      ...orgList.map((item) => ({ text: item.orgName, value: item.id })),
    ];
    if (orgId) {
      this.zrCompanyId = orgId;
    }
    console.log(this.zrCompanyId, "orgId")
    this.zrShow = ['系统管理', '全局管理'].includes(roleStr);
    this.loadData()
  }
}